import api from '..'

export class BeneficiaryGroupService {
  static async findForRefunds(dispatchingId: string) {
    const response = await api.get(`/dispatchings/${dispatchingId}/refunds`)
    return response.data
  }
}
